import React, { useRef, useState, useCallback, useEffect, useMemo } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Button, Spinner, ToastContainer, Toast } from "react-bootstrap";
import DOMPurify from "dompurify";
import ErrorExtractor from "../common/error_extractor";
import CommonDropdown from "../common/common_dropDown";
import deleteIcon from "../../assets/svg/delete-po.svg";
import { submitStopsAPI, updateStopsAPI, getStopsEditApi } from "../stops/stops-api";
import Sidebar from "../common/Sidebar";
import "./milestone.css";
import TreeBuilder from "./tree-builder";
import { getMilestoneStatusApi, submitMilestoneAPI, updateMilestoneAPI, getMilestoneEditApi } from "./milestone-api";
import { set } from "date-fns";
import { Navbar } from "../common/Navbar";

export const MilestoneCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  const [milestoneList, setMilestoneList] = useState([]);
  const [removedMilestone, setRemovedMilestone] = useState([]);

  useEffect(() => {
    getMilestoneStatus();
  }, []);

  useEffect(() => {
    if (id != null) {
      getMilestoneEdit(id);
    } else {
      const newNode = {
        parent_id: 0,
        box_id: 1,
        status: "Trip start",
        buffer_time: "00:00",
        title: "Trip Started",
        all: false,
        stoplevel: false,
        attachment: false,
        comment: false,
        skip: false,
        signature: false,
      };
      setMilestoneList([newNode]);
    }
  }, [id]);

  const [milestoneStatusList, setMilestoneStatusList] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [isLoader, setIsLoader] = useState(false);

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [defaultValue, setDefaultValue] = useState(false);
  const [productConfirmation, setProductConfirmation] = useState(false);
  const [paymentImages, setPaymentImages] = useState(false);
  const [payment, setPayment] = useState(false);

  const [errorMsg, setErrorMsg] = useState({
    code: "",
    name: "",
    milestoneflow: "",
  });

  const [groupedError, setGroupedError] = useState({});

  const getMilestoneStatus = async () => {
    try {
      const response = await getMilestoneStatusApi();
      if (response.data.success === true) {
        setMilestoneStatusList(response.data.suggestionlist ?? []);
      }
    } catch (err) {
      console.error("Error fetching cost data:", err);
    } finally {
    }
  };

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();

    try {
      const preSanitizeData = {
        code: code,
        name: name,
        default: defaultValue,
        product_confirmation: productConfirmation,
        payment_images: paymentImages,
        payment: payment,
        milestoneflow: milestoneList,
        removedMilestone: removedMilestone,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitMilestoneAPI(sanitizedData);
      } else {
        response = await updateMilestoneAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        /* const errorvalue = extractor.extractErrors(response.data.error, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue); */
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          Object.entries(response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^milestoneflow\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            milestoneflow: "",
          };
          Object.entries(response?.data?.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();

        navigate(-1);
      } else {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          Object.entries(response?.data?.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^milestoneflow\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            milestoneflow: "",
          };
          Object.entries(response?.data?.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          Object.entries(err.response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^milestoneflow\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            name: "",
            milestoneflow: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      }
    } finally {
      setIsLoader(false);
    }
  };

  const getMilestoneEdit = async (id) => {
    try {
      const response = await getMilestoneEditApi(id);

      if (response.data.success === true) {
        const stopDetail = response.data.milestone ?? {};
        setCode(stopDetail.code ?? "");
        setName(stopDetail.name ?? "");
        setDefaultValue(stopDetail.default ?? false);
        setProductConfirmation(stopDetail.product_confirmation ?? false);
        setPaymentImages(stopDetail.payment_images ?? false);
        setPayment(stopDetail.payment ?? false);
        setMilestoneList(stopDetail.milestoneFlows ?? []);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  // Helpers
  //const nextId = () => Date.now() + Math.floor(Math.random() * 1000);
  const generated = new Set();
  function generateUniqueCode() {
    let code;
    do {
      code = Math.floor(1000 + Math.random() * 9000);
    } while (generated.has(code));

    generated.add(code);
    return code;
  }
  const addChild = (parentId) => {
    const newId = generateUniqueCode();
    const newNode = {
      box_id: newId,
      status: "",
      parent_id: parentId,
      title: "",
      buffer_time: "00:00",
      all: false,
      comment: false,
      skip: false,
      stoplevel: false,
      attachment: false,
      signature: false,
    };
    setMilestoneList((prev) => [...prev, newNode]);
  };

  // remove node and its subtree
  const removeNode = (id) => {
    const nodeIndex = milestoneList.findIndex((x) => x.box_id === id);
    if (
      nodeIndex > -1 &&
      milestoneList[nodeIndex].id != null &&
      milestoneList[nodeIndex].id !== 0
    ) {
      setRemovedMilestone((prev) => [...prev, milestoneList[nodeIndex].id]);
    }
    // collect all ids in subtree
    const toRemove = new Set();
    const mapChildren = {};
    milestoneList.forEach((n) => {
      if (!mapChildren[n.parent_id]) mapChildren[n.parent_id] = [];
      mapChildren[n.parent_id].push(n.box_id);
    });

    const collect = (cur) => {
      toRemove.add(cur);
      const kids = mapChildren[cur] || [];
      kids.forEach(collect);
    };
    collect(id);

    setMilestoneList((prev) => prev.filter((n) => !toRemove.has(n.box_id)));
  };

  const updateNode = (id, newValues) => {
    setMilestoneList((prev) => prev.map((item) => (item.box_id === id ? { ...item, ...newValues } : item)));
  };

  const [zoom, setZoom] = useState(1);

  const handleWheel = (e) => {
    if (e.ctrlKey) {
      e.preventDefault();

      setZoom((z) => {
        const newZoom = z + (e.deltaY > 0 ? -0.05 : 0.05);
        return Math.min(Math.max(newZoom, 0.4), 2);
      });
    }
  };
  function isLeaf(nodeId) {
    return !milestoneList.some((n) => n.parent_id === nodeId);
  }
  function isFirstNode() {
    return milestoneList.length === 1;
  }

  return (
    <div className="d-flex ">
      <Sidebar currentfile="Milestone" />

      <div className="rounded-4 flex-grow-1  " style={{ width: "calc(100vw - 80px)" }}>
        <Navbar pageTitle="Milestone" />
        <div className=" scroll-hidden" style={{ height: "calc(100vh - 56px)", background: "#F5F8FA" }}>
          <div className="px-2 d-flex align-items-center justify-content-between">
            <div className="d-flex gap-3 my-3">
              <MoveLeft
                className="cursor-pointer"
                onClick={() => {
                  navigate(-1);
                }}
              />
              <p className="fw-semibold m-0">New Milestone</p>
            </div>
            <div className="d-flex gap-3">
              <Button
                className="cursor-pointer bg-white rounded-pill px-4 py-2  btn-border-grey fs-15 fw-500"
                style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
              <Button
                className={`cursor-pointer dark-purple-btn ${isLoader ? "disabled-btn" : ""} rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                onClick={() => {
                  submitForm();
                }}
                style={{ minWidth: "100px" }}
              >
                {isLoader ? <Spinner animation="border" size="sm" /> : id != null ? "Update" : "Save"}
              </Button>
            </div>
          </div>
          <div className="col-12 px-2">
            <div className="row mb-2">
              <div className="col-12  pe-0">
                <div className="bg-white rounded-4 d-flex flex-column align-items-start px-2 py-2">
                  <div className="fs-14 fw-700" style={{ color: "#28303F" }}>
                    MILESTONE DETAILS
                  </div>

                  <div className="row w-100">
                    <div className="mt-2 col-12 col-md-4  d-flex flex-column align-items-start">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        Code <span className="error-text">*</span>
                      </div>
                      <div className="w-100">
                        <input type="text" className="form-control rounded-3" placeholder="Enter here..." value={code} onChange={(e) => setCode(e.target.value)} />
                      </div>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "6px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.code}
                      </span>
                    </div>
                    <div className="mt-2 col-12 col-md-4  d-flex flex-column align-items-start">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        Name <span className="error-text">*</span>
                      </div>
                      <div className="w-100">
                        <input type="text" className="form-control rounded-3" placeholder="Enter here..." value={name} onChange={(e) => setName(e.target.value)} />
                      </div>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "6px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.name}
                      </span>
                    </div>
                    <div className="mt-2 col-12 col-md-4  d-flex flex-column align-items-start">
                      <div className="form-label fs-12 fw-400 my-0 mb-1" style={{ color: "#28303F" }}>
                        Checklist
                      </div>
                      <div className="">
                        <input type="checkbox" checked={defaultValue} onChange={(e) => setDefaultValue(e.target.checked)} />
                        <label className="ms-2">Default</label>
                      </div>
                      <div className="mt-2">
                        <input type="checkbox" checked={productConfirmation} onChange={(e) => setProductConfirmation(e.target.checked)} />
                        <label className="ms-2">Product Confirmation</label>
                      </div>

                      <div className="mt-2">
                        <input type="checkbox" checked={paymentImages} onChange={(e) => setPaymentImages(e.target.checked)} />
                        <label className="ms-2">Payment Images</label>
                      </div>
                      <div className="mt-2">
                        <input type="checkbox" checked={payment} onChange={(e) => setPayment(e.target.checked)} />
                        <label className="ms-2">Payment</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="m-2 bg-white rounded-4 p-3">
              <div className="row">
                <div className="col-12 " style={{ overflow: "none" }}>
                  <div className="fs-14 fw-700" style={{ color: "#28303F", textAlign: "left" }}>
                    LEVELS
                  </div>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.milestoneflow}
                  </span>
                  <div className="tree-scroll-container">
                    <div
                      className="tree-zoom-content"
                      style={{
                        transform: `scale(${zoom})`,
                        transformOrigin: "0 0",
                      }}
                      onWheel={handleWheel}
                    >
                      <TreeBuilder data={milestoneList} isLeaf={isLeaf} isFirstNode={isFirstNode} addChild={addChild} removeNode={removeNode} updateNode={updateNode} statusList={milestoneStatusList} groupedError={groupedError} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function buildTree(list) {
  const map = {};
  const roots = [];
  list.forEach((item) => (map[item.box_id] = { ...item, children: [] }));
  list.forEach((item) => {
    if (item.parent_id === 0 || item.parent_id == null) {
      roots.push(map[item.box_id]);
    } else {
      const parent = map[item.parent_id];
      if (parent) parent.children.push(map[item.box_id]);
      else roots.push(map[item.box_id]); // fallback
    }
  });
  return roots;
}
